module.exports = __webpack_public_path__ + "static/media/chat.788d64ff.png";